import "./cookie-compliance";
import "./paragraph-hero";
import "./fancybox";
import "./css-variables";
import "./overlapping-backgrounds";
import "./tippy";
import "./paragraph-brands";
import "./paragraph-story";
import "./paragraph-image-slider";
import "./paragraph-testimonial";
import "./paragraph-tabs";
import "./paragraph-link-blocks";
import "./faq";
import "./page-header";
import "./rwd/menu";
import "./product-finder";
import "./image-marker";
import { gsap, SplitText } from "gsap/all";

(function ($, Drupal) {
  "use strict";

  Drupal.behaviors.dms = {
    attach: function (context, settings) {
      // Mobile menu
      $(once("click", ".js-mm-toggle")).on("click", function (e) {
        $("body").toggleClass("mm-open");
        e.preventDefault();
      });

      // Tracking
      $(once("gtm", 'a[href^="mailto:"]')).addClass("gtm-mail");
      $(once("gtm", 'a[href^="tel:"]')).addClass("gtm-phone");

      // Geysir
      $(once("click", "body")).on(
        "click",
        ".geysir-dialog .horizontal-tab-button a",
        function () {
          $("#geysir-modal").dialog({
            height: "auto",
          });
        }
      );

      $(once('splittext', '.highlight-gradient-blue, .highlight-gradient-green')).each(function () {
        SplitText.create(this, {
          type: "lines",
          mask: "lines",
          autoSplit: true,
          linesClass: "line",
        });
      });

      // Match height
      $(
        once("matchheight", ".node--knowledge-center-item--teaser .title")
      ).matchHeight();

      // Check if on the page this exists: layout--product-finder Then in this element check if any of these items: .productfinder__sidebar .facet-inactive don't have .hidden on them. Then show .productfinder__sidebar
      if (
        $(".layout--product-finder").length &&
        $(".productfinder__sidebar .facet-inactive:not(.hidden)").length
      ) {
        $(".productfinder__sidebar").removeClass("hidden");
      }

      $(once("table-wrapper", "table")).wrap(
        "<div class='table-wrapper'></div>"
      );
    },
  };
})(jQuery, Drupal);
